<template>
	<section class="small-12 flex justify-center helpfulLinks">
        <div class="small-12 large-7 columns">
            <h2 class="small-12 text-center">
                Some helpful links.
            </h2>
            <ul class="small-12 flex float-left">
                <li class="small-12 large-4 columns">
                    <router-link :to="{ name: 'Help' }">
                        Needing help?
                    </router-link>
                </li>
                <li class="small-12 large-4 columns">
                    <router-link :to="{ name: 'BlogCategory', params: { slug: 'about-nestd' } }">
                        Learning more about us?
                    </router-link>
                </li>
                <li class="small-12 large-4 columns">
                    <router-link :to="{ name: 'BlogIndex' }">
                        Interested in some reading?
                    </router-link>
                </li>
            </ul>
        </div>
    </section>
</template>

<script>

	export default {

		/*
		** Set the component name
		*/

		name: 'HelpfulLinks',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			//

		],

		/*
		**  Set the props
		*/

		props: {

			//

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			//

		}),

		/*
		**  Watch em'
		*/

		watch: {

			//

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			//

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>